import { createAction } from 'redux-actions';

export const NAMES = {
  CLOSE_SLIDE_MENU: 'CLIENT.MOBILE.SLIDE_MENU.CLOSE',
  OPEN_SLIDE_MENU: 'CLIENT.MOBILE.SLIDE_MENU.OPEN',
};
export const closeSlideMenu = createAction(NAMES.CLOSE_SLIDE_MENU);
export const openSlideMenu = createAction(NAMES.OPEN_SLIDE_MENU);
